import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ApplicationState, BoundActionCreators, bindThunkActionCreators } from '../../store';
import * as ResourcesListStore from '../../store/ResourcesListStore';
import EntitiesScreenBuilder, { IEntitiesScreenProps } from '../common/EntitiesScreen';
import { IEntitiesScreenView, HeaderProps, EntitiesScreenSubTypeGroup } from '../common/EntitiesScreenHeader';
import EmptyEntitiesScreen from "../common/EmptyEntitiesScreen";
import * as Metadata from "../../entities/Metadata";
import { IDeletionResult } from '../../store/services/storeHelper';
import {
    PrimaryButton, DefaultButton, ContextualMenuItemType, IContextualMenuItem, IDialogContentProps, arraysEqual, MessageBar, MessageBarType, Selection, Link,
    memoizeFunction
} from 'office-ui-fabric-react';
import { CancelTokenSource } from 'axios';
import { cancellablePost } from '../../fetch-interceptor';
import { Dictionary, EntityType, IScalableTimeframe, mapServerEntityType, Quantization, ServerEntityType } from "../../entities/common";
import { Reporting, ReportNav, ReportsNav } from "../utils/reporting";
import ListSubView, { getPngExportConfigSelectors } from "../views/list/ListSubView";
import RemoveDialog from '../common/RemoveDialog';
import EditListSubView from '../views/list/EditListSubView';
import ImportPanel, { supported } from "../import/resource/ImportPanel";
import MergePanel from "./MergePanel/MergePanel";
import { UserState } from '../../store/User';
import { CommonOperations, canCreateResource, canResourceAnyRead, contains } from '../../store/permissions';
import { toDictionaryById, notUndefined, waitForFinalEvent, distinct, formatFieldValue } from "../utils/common";
import Spinner from "../common/Spinner";
import ResourceCreation from './ResourceCreation';
import { ResourceFilterValue, FilterHelper } from '../../store/resource/filters';
import * as Notifications from "../../store/NotificationsStore";
import * as LayoutsStore from "../../store/layouts";
import * as FiltersStore from "../../store/filters";
import * as ViewsStore from '../../store/views';
import { defaultCatch, mergeDefault } from '../../store/utils';
import { IDetailsProps, IListProps, OnItemRender, TInlineEditProps } from '../common/extensibleEntity/EntityDetailsList';
import { default as GenericEntitiesFilter } from '../common/EntitiesFilter';
import { Integrations, Subscription, PPMFeatures, RoutesAvailability, RouteAvailabilitySettings, ToRouteAvailabilitySettings } from '../../store/Tenant';
import { LayoutService } from '../utils/LayoutService';
import { ITimelineProps } from '../common/extensibleEntity/EntityTimelineList';
import { ScaleRenderMode } from '../common/timeline/TimelineBody';
import UtilizationTooltipContent from './usage/UtilizationTooltipContent';
import AssignmentsTooltipContent from './usage/AssignmentsTooltipContent';
import UtilizationList from './UtilizationList';
import { defaultTimeframe, SCALE_MULTIPLIER_PER_TIMETYPE_COLUMN, ViewType } from './usage/ResourceUsageGrid';
import { IRow } from '../common/timeline/TimelineList';
import { IScaleTimelineSegment } from '../common/timeline/TimelineSegment';
import MenuWithReports from '../reporting/MenuWithReports';
import PngExporter, { PngExportConfig } from '../common/PngExporter';
import { PngExportControlDetails } from '../../store/PngExporterStore';
import { TimeTypeSelector, ResourceUsageCell, calculateAssignmentsSummaryData, calculateResourcePlanSummaryData } from './usage/ResourceUsageCell';
import { SortService } from '../../services/SortService';
import { Sorter } from '../utils/HierarchyManager';
import { buildExportToCsvMenuItem } from '../common/headerMenuItemBuilders';
import { MenuTitleBuilder } from '../MenuTitleBuilder';
import ReportedTimeList from './ReportedTimeList';
import ApplyLayoutConfirmationDialog from '../common/ApplyLayoutConfirmationDialog';
import { ConfirmationDialog } from '../common/ConfirmationDialog';
import { onScaleChanged } from './usage/ResourceUsageGrid/BaseUsageGrid';
import { IBulkEditInput } from '../common/EntitiesBulkEdit';
import { IEntityMapHelper, useEntityMapHelper } from '../utils/IEntityMapHelper';
import { nameof } from '../../store/services/metadataService';
import { ResourceAttrs } from '../../store/ResourcesListStore';
import { IWithSearch, withSearch } from '../common/withSearch';
import { getDefaultCostRateTable } from '../../store/selectors/costRateTableSelectors';
import { FieldsState } from '../../store/fields';
import { SearchFieldService } from '../common/SearchFieldService';
import { getTimephasedInlineEditState, tryGetTimephasedValueFromResource } from '../../services/TimephasedValueService';
import { resolveTimephasedFieldFromStore } from '../../services/TimephasedConfigService';
import { CostRateTable } from '../../store/CostRateTableStore';
import { DisplayFieldService } from '../common/DisplayFieldService';
import { IInputProps } from '../common/interfaces/IInputProps';
import { IValidator } from '../../validation';
import {
    CellSummaryContext,
    defaultTimeType,
    TimeType,
    timeTypesConfigMap
} from './usage/ResourceUsageCell/common';
import {
    AssignmentsTotals,
    AssignmentsWork,
    assignmentTimeTypesConfigMap,
    buildAssignmentsTotalFields,
    ServerAssignmentsByDay,
    toAssignmentsByDay
} from './usage/assignments';
import { ResourceTimelineGroup, ViewTypeGroup, ViewTypeGroups, ViewsTypes } from '../common/ViewTypeSelect';
import { MenuButtonPicker } from '../common/inputs/MenuItemsPicker';
import { Calendar } from '../../store/calendar/common';

type ActionProps = {
    resourcesActions: BoundActionCreators<typeof ResourcesListStore.actionCreators>;
    notificationsActions: typeof Notifications.actionCreators;
    filtersActions: ReturnType<typeof FiltersStore.actionCreators.forEntity>;
    viewsActions: ReturnType<typeof ViewsStore.actionCreators.forEntity>;
}

type StateProps = {
    views?: ViewsStore.IViewsState;
    resources: ResourcesListStore.Resource[];
    resourcesMap: IEntityMapHelper<ResourcesListStore.Resource>;
    layouts: LayoutsStore.LayoutsState;
    resourceFields: Metadata.Field[];
    resourceFakeFields: Metadata.Field[];
    resourceFilters: Metadata.IFilter<ResourceFilterValue>[];
    resourceReports: ReportNav[];
    resourcesReports: ReportsNav;
    activeFilter?: Metadata.IFilter<ResourceFilterValue>;
    autoFilterId: string;
    deletionResult: IDeletionResult[] | undefined;
    user: UserState;
    subscription: Subscription,
    isImportDialogOpen: boolean;
    isLoading: boolean;
    isListLoading: boolean;
    isLoadingUsage: boolean;
    integrations: Integrations;
    pngExportDetails?: PngExportControlDetails;
    resourcePlanningLevel: EntityType;
    routeAvailabilitySettings: RouteAvailabilitySettings;
    defaultCostRateTable?: CostRateTable;
    fieldsStore?: Record<string, FieldsState>;
};

export type ResourcesListProps = StateProps & ActionProps & RouteComponentProps<{ type?: string, subViewId?: string }> & IWithSearch;

type State = {
    isCreate: boolean;
    isImport: boolean;
    isMerge: boolean;
    isListViewEdit: boolean;
    isTimelineViewEdit: boolean;
    resourcesToRemove: ResourcesListStore.Resource[];
    resourcesNotRemoved: ResourcesListStore.Resource[];
    resourceNotDeactivated: ResourcesListStore.Resource[];
    resourceNotActivated: ResourcesListStore.Resource[];
    layoutToApply?: Metadata.Layout;
    canManageConfiguration: boolean;
    canManage: boolean;
    selectedItemIds: string[];
    quantization: Quantization;
    entityFilterHelper: Metadata.IEntityFilterHelper<ResourcesListStore.Resource>;
    applyCalendar?: Calendar;
    assignmentsByDay: Dictionary<Dictionary<AssignmentsWork>>;
    assignmentsTotals: Dictionary<AssignmentsTotals>;
    isLoadingAssignments: boolean;
};

type TimelineGroupSettings = {
    viewType: ViewType;
    timeType?: Dictionary<boolean>;
};

type ResourcesSettings = {
    timelineGroup: ResourceTimelineGroup;
    resourcePlan: TimelineGroupSettings;
    assignments: TimelineGroupSettings;
};

const EntitiesFilter = GenericEntitiesFilter<ResourcesListStore.Resource>();
const EntitiesScreen = EntitiesScreenBuilder<ResourcesListStore.Resource>();
const minCountMerge = 2;
const debounceDelay = 600;
const defaultResourcesSettings: ResourcesSettings = {
    timelineGroup: 'resourcePlan',
    resourcePlan: { viewType: ViewType.Hours },
    assignments: { viewType: ViewType.Hours }
};

class ResourcesList extends React.Component<ResourcesListProps, State> {
    private _selection: Selection;
    private _debouncedLoadUsages: () => void;
    private _debouncedLoadAssignments: (resourceIds: string[], timeframe: IScalableTimeframe) => void;
    private _timeframe?: IScalableTimeframe;
    private _assignmentsTotalsResourceIds: string[] = [];
    private _assignmentsCancelTokenSource?: CancelTokenSource;
    private _assignmentsTotalsCancelTokenSource?: CancelTokenSource;

    constructor(props: ResourcesListProps) {
        super(props);

        this.state = {
            isCreate: false,
            isImport: false,
            isMerge: false,
            isListViewEdit: false,
            isTimelineViewEdit: false,
            canManageConfiguration: contains(props.user.permissions.common, CommonOperations.ConfigurationManage),
            canManage: canCreateResource(props.user.permissions.resource),
            selectedItemIds: [],
            resourcesToRemove: [],
            resourcesNotRemoved: [],
            resourceNotDeactivated: [],
            resourceNotActivated: [],
            quantization: Quantization.months,
            entityFilterHelper: this._buildEntityFilterHelper(props),
            assignmentsByDay: {},
            assignmentsTotals: {},
            isLoadingAssignments: false
        };
        this._debouncedLoadUsages = waitForFinalEvent((resourceIds, timeframe) => this.props.resourcesActions.loadUsages(resourceIds, timeframe), debounceDelay, 'resource-list');
        this._debouncedLoadAssignments = waitForFinalEvent((resourceIds, timeframe) => this._loadAssignments(resourceIds, timeframe), debounceDelay, 'resource-list-assignments');

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({ selectedItemIds: (this._selection.getSelection() as ResourcesListStore.Resource[]).map(_ => _.id) });
            }
        });
    }

    componentWillMount() {
        this.props.resourcesActions.loadResources(true);
    }

    componentWillReceiveProps(nextProps: ResourcesListProps) {
        if (!arraysEqual(this.props.resourceFields, nextProps.resourceFields) || !arraysEqual(this.props.resources, nextProps.resources)) {
            this.setState({ entityFilterHelper: this._buildEntityFilterHelper(nextProps) });
        }
    }

    componentDidMount() {
        this._loadDisplayedAssignmentsTotals();
    }

    componentDidUpdate(prevProps: ResourcesListProps) {
        const { timelineGroup } = this._getSettings();
        if (this._timeframe && timelineGroup === 'assignments' && (prevProps.views!.timeline.data as ResourcesSettings).timelineGroup !== timelineGroup) {
            this._debouncedLoadAssignments(this._getTimelineResourceIds(), this._timeframe);
        }
        this._loadDisplayedAssignmentsTotals();
    }

    componentWillUnmount() {
        this._assignmentsCancelTokenSource?.cancel();
        this._assignmentsTotalsCancelTokenSource?.cancel();
    }

    private _buildEntityFilterHelper(props: ResourcesListProps) {
        return new FilterHelper({
            fields: props.resourceFields,
            resources: props.resources,
            layouts: props.layouts.allIds.map(_ => props.layouts.byId[_]),
            defaultCostRateTableId: props.defaultCostRateTable?.id,
            fieldsStore: props.fieldsStore
        });
    }

    private _viewChanged = (view: IEntitiesScreenView<ResourcesListStore.Resource>) => {
        this._clearSelection();
        this.props.viewsActions.setActiveView(view.url);
    }

    render() {
        const { deletionResult } = this.props;
        const notDeleted = deletionResult?.filter(_ => !_.isDeleted);
        if (!this.props.isImportDialogOpen && (this.props.isLoading || this.props.isListLoading)) {
            return <Spinner />;
        }
        const { resourcesToRemove, resourceNotDeactivated, resourceNotActivated, resourcesNotRemoved } = this.state;
        const integrations = this.props.integrations.getAvailable(supported);

        const unassign = notDeleted && <>
            <span>We recommend using the 'Merge Resources' option to replace {notDeleted.length > 1 ? "these resources" : "this resource"} and merge their existing data into another resource selected as a replacement.
                Alternatively, you can unassign or remove {notDeleted.length > 1 ? "these resources" : "this resource"} from the fields first. </span>
            <Link href="https://help.ppm.express/111183-resource-management/resource-merging?from_search=149628615" target="_blank">
                Learn more
            </Link>
        </>

        const selectedItems = this.props.resourcesMap.getItems(this.state.selectedItemIds);

        return <>
            {this.props.resources.length === 0
                ? this.state.canManage
                    ? <EmptyEntitiesScreen
                        className="resource"
                        title="resources"
                        description="Add people to your organization team for effective status reporting and management accessible for all your team members">
                        <PrimaryButton disabled={!this.state.canManage} text="Create Resource" onClick={() => this.setState({ isCreate: true })} />
                        {!!integrations.length && <DefaultButton disabled={!this.state.canManage} text="Import Resources" onClick={() => this.setState({ isImport: true })} />}
                    </EmptyEntitiesScreen>
                    : <EmptyEntitiesScreen
                        className="resource"
                        title="resources"
                        description="You are not assigned as a Direct Manager or Resource Manager for any resources. Please contact your tenant administrator to request access to the required resources.">
                    </EmptyEntitiesScreen>
                : this.props.match.params.type === 'plan'
                    ? <UtilizationList resourceIds={this.getSelectedResources().map(_ => _.id)} resourcePlanningLevel={this.props.resourcePlanningLevel} />
                    : this.props.match.params.type === 'reported-time'
                        ? <ReportedTimeList resourceIds={this.getSelectedResources().map(_ => _.id)} />
                        : <PngExporter details={this.props.pngExportDetails} getConfig={this._getPngExportConfig}>
                            <EntitiesScreen {...this._buildEntitiesScreenProps()} />
                        </PngExporter>}
            {this.state.isCreate && <ResourceCreation onDismiss={() => this.setState({ isCreate: false })} openOnComplete={true} />}
            {this.state.isImport && <ImportPanel integrations={integrations} onDismiss={this._onImportDismiss} />}
            {this.state.isMerge &&
                (selectedItems.filter(_ => _.attributes.LinkedUser).length < 2
                    ? <MergePanel
                        selected={selectedItems}
                        onDismiss={() => this.setState({ isMerge: false })}
                        onComplete={() => this._clearSelection()}
                    />
                    : <ConfirmationDialog
                        onDismiss={() => this.setState({ isMerge: false })}
                        onYes={() => this.setState({ isMerge: false })}
                        yesButtonProps={{ text: "Got it" }}
                        dialogContentProps={{
                            title: 'Unable to merge resources',
                            subText:
                                `The following resources cannot be merged because there are users associated with these resources:
                                ${selectedItems.filter(_ => _.attributes.LinkedUser).map(_ => _.name).join('\n')}
                               Consider using Replace User feature in People Management instead.`
                        }} />
                )}
            {!!this.state.resourcesToRemove.length && <RemoveDialog
                onClose={() => this.setState({ resourcesToRemove: [] })}
                onComplete={() => {
                    this._clearSelection();
                    this.props.resourcesActions.removeResources(resourcesToRemove.map(_ => _.id));
                }}
                dialogContentProps={this._getRemoveDialogContent(resourcesToRemove)}
                confirmButtonProps={{ text: "Delete" }} />}
            {!!resourceNotDeactivated.length && <ConfirmationDialog
                onDismiss={() => this.setState({ resourceNotDeactivated: [] })}
                onYes={() => this.setState({ resourceNotDeactivated: [] })}
                yesButtonProps={{ text: "Got it" }}
                dialogContentProps={{
                    title: `Unable to deactivate resource${resourceNotDeactivated.length > 1 ? 's' : ''}`,
                    subText:
                        resourceNotDeactivated.length === 1
                            ? `Resource ${resourceNotDeactivated[0].name} cannot be deactivated because there is a user associated with this resource.
                               Deactivate this user and associated resource will be deactivated automatically.`
                            : `The following resources cannot be deactivated because there are users associated with these resources:
                                ${resourceNotDeactivated.map(_ => _.name).join('\n')}
                               Deactivate the user${resourceNotDeactivated.length > 1 ? 's' : ''} and associated resource${resourceNotDeactivated.length > 1 ? 's' : ''} will be deactivated automatically.`
                }} />
            }
            {!!resourceNotActivated.length && <ConfirmationDialog
                onDismiss={() => this.setState({ resourceNotActivated: [] })}
                onYes={() => this.setState({ resourceNotActivated: [] })}
                yesButtonProps={{ text: "Got it" }}
                dialogContentProps={{
                    title: `Unable to activate resource${resourceNotActivated.length > 1 ? 's' : ''}`,
                    subText:
                        resourceNotActivated.length === 1
                            ? `Resource ${resourceNotActivated[0].name} cannot be activated because there is a user associated with this resource.
                               Activate this user and associated resource will be activated automatically.`
                            : `The following resources cannot be activated because there are users associated with these resources:
                                ${resourceNotActivated.map(_ => _.name).join('\n')}
                               Activate the user${resourceNotActivated.length > 1 ? 's' : ''} and associated resource${resourceNotActivated.length > 1 ? 's' : ''} will be activated automatically.`
                }} />
            }
            {!!resourcesNotRemoved.length && <ConfirmationDialog
                onDismiss={() => this.setState({ resourcesNotRemoved: [] })}
                onYes={() => this.setState({ resourcesNotRemoved: [] })}
                yesButtonProps={{ text: "Got it" }}
                dialogContentProps={{
                    title: `Unable to delete resource${resourcesNotRemoved.length > 1 ? 's' : ''}`,
                    subText:
                        resourcesNotRemoved.length === 1
                            ? `Resource ${resourcesNotRemoved[0].name} cannot be deleted because there is a user associated with this resource.
                               Consider deactivating the user and the resource instead of deletion.`
                            : `The following resources cannot be deleted because there are users associated with these resources:
                                ${resourcesNotRemoved.map(_ => _.name).join('\n')}
                               Consider deactivating these users and resources instead of deletion.`
                }} />
            }
            {deletionResult && notDeleted && <RemoveDialog
                onClose={() => { this.props.resourcesActions.dismissDeletionResult() }}
                confirmButtonProps={{ text: "Got it" }}
                modalProps={{ styles: { main: { minWidth: 500 } } }}
                dialogContentProps={this._getDeletionResultDialogContent(deletionResult)}>
                {deletionResult.length > 1 && notDeleted.length > 0 && <MessageBar messageBarType={MessageBarType.warning} isMultiline>
                    Failed to delete the following {notDeleted.length > 1 ? "resources as they are" : "resource as the resource is"} in use:
                    <ul>
                        {notDeleted.map(_ => <li key={_.id}>{_.message}</li>)}
                    </ul>
                </MessageBar>}
                {notDeleted.length > 0 && <MessageBar messageBarType={MessageBarType.info} isMultiline>
                    {unassign}
                </MessageBar>}
            </RemoveDialog>}
            {this.state.layoutToApply && <ApplyLayoutConfirmationDialog
                onConfirm={() => {
                    this.props.resourcesActions.applyLayoutMany(this.state.selectedItemIds, this.state.layoutToApply!.id);
                    this.props.notificationsActions.pushNotification({
                        message: `Layout '${this.state.layoutToApply!.name}' applied`,
                        type: Notifications.NotificationType.Info
                    });
                }}
                onDismiss={() => this.setState({ layoutToApply: undefined })}
                entityType={EntityType.Resource}
                layoutName={this.state.layoutToApply!.name}
                count={this.state.selectedItemIds.length}
            />}
            {!!this.state.applyCalendar && <ConfirmationDialog
                dialogContentProps={{
                    isMultiline: true,
                    title: "Apply Calendar",
                    subText: `Are you sure you want to apply a calendar ${this.state.applyCalendar.attributes.Name} to the selected resource` +
                        (this.state.selectedItemIds.length > 1 ? `s (${this.state.selectedItemIds.length} items)?` : "?")
                }}
                yesButtonProps={{ text: "Confirm" }}
                noButtonProps={{ text: "Cancel" }}
                onDismiss={() => this.setState({ applyCalendar: undefined })}
                onNo={() => { }}
                onYes={() => {
                    this.props.resourcesActions.bulkApplyCalendar(this.state.selectedItemIds, this.state.applyCalendar?.id!);
                }}
            >
                <MessageBar messageBarType={MessageBarType.warning} isMultiline>
                    Changing the calendar will update the resource plans these resources are allocated to and their assigned PPM Express tasks according to the new calendar.<br />
                    Resources that already have {this.state.applyCalendar.attributes.Name} set or use personal work week settings will not be affected.
                </MessageBar>
            </ConfirmationDialog>}
        </>;
    }

    private _buildEntitiesScreenProps(): IEntitiesScreenProps<ResourcesListStore.Resource> {
        return {
            title: "resources",
            canManageConfiguration: this.state.canManageConfiguration,
            activeViewType: this.props.views!.activeViewType,
            viewChanged: this._viewChanged,
            selection: this._selection,
            fields: this.props.resourceFields,
            fakeFields: this.props.resourceFakeFields,
            defaultBulkEditColumns: ResourcesListStore.DEFAULT_BULK_EDIT_COLUMNS,
            getBulkEditEntities: this.getSelectedResources,
            bulkEditAttributesCustomRender: this.bulkEditAttributesCustomRenderBuilder(),
            entities: this.applyFilter(this.props.resources),
            entitiesIsUpdating: this.props.layouts.isApplyingLayout,
            actions: {
                bulkComponent: {
                    bulkUpdate: this.gridBulkUpdate
                },
                importFromFile: this.props.resourcesActions.importEntitiesFromFile
            },
            views: this._getViews(),
            filter: {
                activeFilter: this.props.activeFilter,
                autoFilterId: this.props.autoFilterId,
                getAttributeValue: this.getAttributeValue,
                onFilterRender: this._renderFilter
            },
            headerProps: this.getHeaderProps(),
            router: {
                history: this.props.history,
                match: this.props.match,
                location: this.props.location
            },
            baseUrl: "/resources",
            canEdit: this._canEdit(),
            selectedItemIds: this.state.selectedItemIds,
            getPngExportConfig: this._getPngExportConfig,
            search: this.props.search,
            readonlyFields: !canCreateResource(this.props.user.permissions.resource)
                ? [
                    nameof<ResourceAttrs>("ResourceManager"),
                    nameof<ResourceAttrs>("DirectManager")
                ]
                : undefined
        }
    }

    private getStatusFieldConfig(): IBulkEditInput {
        return {
            editable: (entity: ResourcesListStore.Resource) => !entity.attributes.LinkedUser
        }
    }

    private bulkEditAttributesCustomRenderBuilder = (): Dictionary<IBulkEditInput> => {
        const timephasedConfigs = this.props.resourceFields
            .filter(_ => _.type === Metadata.FieldType.TimephasedValue)
            .reduce((acc, field) => {
                acc[field.name] = this.getTimephasedBulkEditFieldConfig(field);
                return acc;
            }, {} as Dictionary<IBulkEditInput>);

        return {
            "Status": this.getStatusFieldConfig(),
            ...timephasedConfigs,
        };
    }

    private getTimephasedBulkEditFieldConfig(field: Metadata.Field): IBulkEditInput {
        const resolvedField = resolveTimephasedFieldFromStore(this.props.fieldsStore, field) ?? field;
        const validator = DisplayFieldService.buildValidatorFromField(resolvedField);
        return {
            editable: (entity: ResourcesListStore.Resource) => {
                const inlineState = getTimephasedInlineEditState(field.name, entity, this.props.defaultCostRateTable?.id);
                return !!entity.isEditable && inlineState.isInlineEditable;
            },
            getValue: (entity: ResourcesListStore.Resource) =>
                entity.attributes[field.name] !== undefined
                    ? entity.attributes[field.name]
                    : tryGetTimephasedValueFromResource(field.name, entity, new Date(), this.props.defaultCostRateTable?.id),
            validator: () => validator,
            field: resolvedField,
            render: (props: IInputProps) => {
                return DisplayFieldService.buildCompactFieldInputElement(resolvedField, props);
            }
        };
    }

    private getTimephasedInlineValidators = (): Dictionary<(state: ResourcesListStore.Resource, field: Metadata.Field) => IValidator> => {
        return this.props.resourceFields
            .filter(_ => _.type === Metadata.FieldType.TimephasedValue)
            .reduce((acc, field) => {
                const resolvedField = resolveTimephasedFieldFromStore(this.props.fieldsStore, field) ?? field;
                const validator = DisplayFieldService.buildValidatorFromField(resolvedField);
                acc[field.name] = () => validator;
                return acc;
            }, {} as Dictionary<(state: ResourcesListStore.Resource, field: Metadata.Field) => IValidator>);
    }

    private _onImportDismiss = () => {
        this.setState({ isImport: false });
    }

    private _getRemoveDialogContent(toRemove: ResourcesListStore.Resource[]) {
        toRemove = toRemove.filter(_ => _.isEditable);
        if (toRemove.length === 1) {
            return {
                title: "Delete resource",
                subText: `Are you sure you want to delete resource "${toRemove[0].attributes.Name}"?`
            }
        }

        return {
            title: "Delete resources",
            subText: toRemove.length
                ? `Are you sure you want to delete selected resources (${toRemove.length} resources)?`
                : undefined
        }
    }

    private _getDeletionResultDialogContent(deletionResult: IDeletionResult[]): IDialogContentProps {
        if (deletionResult.length === 1 && !deletionResult[0].isDeleted) {
            return {
                title: "Unable to delete resource",
                subText: deletionResult[0].message
            };
        }

        const deleted = deletionResult.filter(_ => _.isDeleted);
        return deleted.length === 1
            ? {
                title: "Resource deletion is complete",
                subText: `Resource "${deleted[0].name}" was deleted successfully.`
            }
            : deleted.length
                ? {
                    title: "Resources deletion is complete",
                    subText: `Selected resources (${deleted.length} resources) were deleted successfully.`
                }
                : {
                    title: "Resources deletion failed"
                };
    }

    private getSelectedResources = (): ResourcesListStore.Resource[] =>
        this.state.selectedItemIds.length
            ? this.props.resourcesMap.getItems(this.state.selectedItemIds)
            : this.applyFilter(this.props.resources);

    private getHeaderProps = (): HeaderProps => {
        const { resourcesReports, history } = this.props;

        const reportItems = resourcesReports.packs.map(_ => (
            {
                key: _.id,
                name: _.title,
                iconProps: { iconName: "FileSymlink" },
                onClick: () => Reporting.openReport(history, _)
            }));

        const resourceReportItems = resourcesReports.subPacks.map(_ => (
            {
                key: _.id,
                name: _.title,
                iconProps: { iconName: "FileSymlink" },
                onClick: () => Reporting.openResourcesReport(history, _, this.getSelectedResources())
            }));

        return {
            entityType: EntityType.Resource,
            createEntityTypes: [EntityType.Portfolio, EntityType.Program, EntityType.Project, EntityType.Roadmap, EntityType.Resource, EntityType.PrivateProject],
            importEntityTypes: [EntityType.Project, EntityType.Resource],
            reportProps: {
                reportsButtonAdditionalOptions: Reporting.buildReportsList(resourceReportItems, reportItems)
            },
            allowExportToFile: true,
            allowImportFromFile: Subscription.contains(this.props.subscription, PPMFeatures.ResourceManagement)
                && canResourceAnyRead(this.props.user.permissions.resource),
        };
    }

    private applyFilter = (_: ResourcesListStore.Resource[]) => {
        return _.filter(this._isItemVisible);
    }

    private _renderFilter = (isFilterPanelOpen: boolean, toggleFilterPanel: () => void) => (
        <EntitiesFilter
            canManageConfiguration={this.state.canManageConfiguration}
            activeFilter={this.props.activeFilter}
            onActiveFilterChanged={this.props.filtersActions.setActiveFilter}
            onFilterChanged={this.props.filtersActions.updateFilter}
            isFilterPanelOpen={isFilterPanelOpen}
            toggleFilterPanel={toggleFilterPanel}
            entityType={EntityType.Resource}
            entityFilterHelper={this.state.entityFilterHelper}
        />
    );

    private _isItemVisible = (item: ResourcesListStore.Resource): boolean => {
        const { activeFilter, search } = this.props;

        if (search?.search && !SearchFieldService.isItemVisible(search.search, item, undefined, this.props.defaultCostRateTable?.id, this.props.fieldsStore)) {
            return false;
        }

        if (activeFilter) {
            const filterValue = activeFilter.value;

            const allAttributes = this.state.entityFilterHelper.getFilterAttributes(this.props.resourceFields);

            for (const type in filterValue) {
                const validateItem = this.state.entityFilterHelper.helpersMap[type].validateItem(item, filterValue[type], allAttributes.filter(_ => _.type === type));
                if (!validateItem) {
                    return false;
                }
            }
        }

        return true;
    }

    private getAttributeValue = (attrType: keyof ResourceFilterValue, value: any): string[] => {
        return this.state.entityFilterHelper.helpersMap[attrType].getAttributeValues(value);
    }

    private _onDeactivate(entities: ResourcesListStore.Resource[]) {
        const toDeactivate = entities.filter(_ => !_.attributes.LinkedUser);
        this.props.resourcesActions.updateStatuses(toDeactivate.map(_ => _.id), ResourcesListStore.ResourceStatus.Inactive);
        this.setState({ resourceNotDeactivated: entities.filter(_ => _.attributes.LinkedUser) })
    }

    private _onActivate(entities: ResourcesListStore.Resource[]) {
        const toActivate = entities.filter(_ => !_.attributes.LinkedUser);
        this.props.resourcesActions.updateStatuses(toActivate.map(_ => _.id), ResourcesListStore.ResourceStatus.Active);
        this.setState({ resourceNotActivated: entities.filter(_ => _.attributes.LinkedUser) })
    }

    private _onRemove(entities: ResourcesListStore.Resource[]) {
        if (entities.some(_ => _.attributes.LinkedUser)) {
            this.setState({ resourcesNotRemoved: entities.filter(_ => _.attributes.LinkedUser) });
        }
        else {
            this.setState({ resourcesToRemove: entities });
        }
    }

    private _renderMenu = (entity: ResourcesListStore.Resource) => {
        let commands: IContextualMenuItem[] = [];

        if (entity.isEditable) {
            commands = commands.concat([
                {
                    key: 'divider_1',
                    itemType: ContextualMenuItemType.Divider
                },
                {
                    key: 'pfedit',
                    name: 'Edit',
                    iconProps: { iconName: "Edit" },
                    onClick: () => this.props.history.push(this._getResourceLink(entity))
                },
                entity.attributes.Status === ResourcesListStore.ResourceStatus.Active
                    ? {
                        key: 'deactivate',
                        name: 'Deactivate',
                        iconProps: { iconName: 'Blocked2' },
                        onClick: () => this._onDeactivate([entity])
                    }
                    : {
                        key: 'activate',
                        name: 'Activate',
                        iconProps: { iconName: 'AddTo' },
                        onClick: () => this._onActivate([entity])
                    },
                canCreateResource(this.props.user.permissions.resource)
                    ? {
                        key: 'pfDelete',
                        name: 'Delete',
                        iconProps: { iconName: "Delete", style: { color: 'red' } },
                        style: { color: 'red' },
                        onClick: () => this._onRemove([entity])
                    }
                    : undefined
            ].filter(notUndefined));
        }

        return <MenuWithReports
            commands={commands}
            item={entity}
            entityType={EntityType.Resource}
            reports={this.props.resourceReports}
            onClick={_ => Reporting.openResourceReport(this.props.history, _, entity)} />;
    }

    private _getResourceLink = (entity: ResourcesListStore.Resource) => {
        return `/resource/${entity.id}`;
    }

    private onInlineEditComplete = (field: Metadata.Field, item: ResourcesListStore.Resource, value: any) => {
        return this.props.resourcesActions.bulkUpdate({ [item.id]: { [field.name]: value } }, { inlineEdit: true });
    }

    private getReadonlyFields = (_: ResourcesListStore.Resource) =>
        (_.attributes?.LinkedUser
            ? this.props.resourceFakeFields.map(__ => __.name).concat(nameof<ResourceAttrs>('Status'))
            : this.props.resourceFakeFields.map(__ => __.name))
            .concat(!canCreateResource(this.props.user.permissions.resource)
                ? [
                    nameof<ResourceAttrs>("ResourceManager"),
                    nameof<ResourceAttrs>("DirectManager")
                ]
                : []);

    private getInlineEditProps = (): TInlineEditProps | undefined =>
        this._canEdit() ? {
            onInlineEditComplete: this.onInlineEditComplete,
            readonlyFields: this.getReadonlyFields,
            customFieldValidatorBuilder: this.getTimephasedInlineValidators()
        } : undefined;

    private getListView = (): IEntitiesScreenView<ResourcesListStore.Resource> => {
        const { list } = this.props.views!;
        const fields = this.props.views!.list.fakeFields.concat(this.props.resourceFields);
        return {
            subViews: list.subViews.allIds.map(_ => list.subViews.byId[_]),
            icon: 'PPMXListView',
            title: 'Resources',
            url: 'list',
            activeSubViewId: list.activeSubViewId,
            onSubViewChange: this.props.viewsActions.setListActiveSubView,
            onEditSubViewClick: id => {
                if (list.activeSubViewId !== id) {
                    this.props.history.push(`/resources/list/${id}`)
                }
                this.setState({ isListViewEdit: true });
            },
            onCopySubViewClick: this._onCopyListSubView,
            onRemoveSubViewClick: this.props.viewsActions.removeListSubView,
            render: (key: string, activeSubView: Metadata.IListSubView, entities: ResourcesListStore.Resource[]) => {
                const listProps: Partial<IListProps> & IDetailsProps = {
                    onItemMenuRender: this._renderMenu,
                    isVirtualizationDisabled: this.props.pngExportDetails?.isInProgress,
                    inlineEditProps: this.getInlineEditProps()
                };
                return [
                    <ListSubView
                        key="list-view"
                        type="Details"
                        entities={entities}
                        selection={this._selection}
                        entityType={EntityType.Resource}
                        fields={fields}
                        isFieldFake={this._buildIsFieldFake()}
                        sort={list.sortBy}
                        sorter={this._sorter}
                        onSortChange={this.props.viewsActions.changeListViewSort}
                        view={activeSubView}
                        listProps={listProps}
                        selectionModeItems={this._buildSelectedModeMenuItems(activeSubView)}
                        onColumnResized={(id, w) => this.props.viewsActions.onListColumnResized(activeSubView.id, id, w)}
                        scaleMultiplier={this._getScaleMultiplier()} />,
                    this.state.isListViewEdit ? <EditListSubView
                        key="create-list-view"
                        subView={activeSubView}
                        entityType={EntityType.Resource}
                        selectedByDefault={this.props.views!.list.selectedByDefault}
                        fields={fields}
                        onChange={changes => this.props.viewsActions.updateListSubView(activeSubView.id, changes)}
                        onSave={() => {
                            this.props.viewsActions.saveListSubView(activeSubView, 'resources');
                            this.setState({ isListViewEdit: false });
                        }}
                        onCopy={() => this._onCopyListSubView(activeSubView)}
                        onDismiss={() => this.setState({ isListViewEdit: false })}
                    /> : <span key="no-edit"></span>
                ];
            },
            onAddSubViewClick: () => {
                const subView = Metadata.SubView.empty();
                this.props.viewsActions.addListSubView(subView);
                this.props.history.push(`/resources/list/${subView.id}`);
                this.setState({ isListViewEdit: true });
            }
        }
    }

    private _onCopyListSubView = (view: Metadata.IListSubView) => {
        const subView = Metadata.SubView.copy(view);
        this.props.history.push(`/resources/list/${subView.id}`);
        this.setState({ isListViewEdit: true });
        this.props.viewsActions.saveListSubView(subView, 'resources', undefined, view.id);
    }

    private _clearSelection = () => {
        this._selection.setAllSelected(false);
    }

    private _buildSelectedModeMenuItems = (activeSubView: Metadata.ISubView): IContextualMenuItem[] | undefined => {
        const { resourcesActions, subscription, user, routeAvailabilitySettings } = this.props;
        const { selectedItemIds, canManage } = this.state;
        const selectedItems = this.props.resourcesMap.getItems(selectedItemIds);
        const selectedEditable = canManage || selectedItems.every(_ => _.isEditable);
        const layoutMenuItem = LayoutService.buildApplyLayoutMenuItem(this.props.layouts, (layout: Metadata.Layout) => {
            this.setState({ layoutToApply: layout });
        });
        const selectedCount = selectedItemIds.length;
        const selectedActiveCount = this.getSelected(ResourcesListStore.ResourceStatus.Active).length;
        const entitiesScreenProps = this._buildEntitiesScreenProps();

        return [
            {
                key: "bulk-edit",
                text: "Bulk edit",
                iconProps: { iconName: "TripleColumnEdit" },
                disabled: !selectedEditable,
                onClick: () => this.props.history.push(`/resources/bulk`),
            },
            RoutesAvailability.ResourcePlan(subscription, user) ? {
                key: "planning-and-utilization",
                text: "Planning and Utilization",
                iconProps: { iconName: "PPMXSectionResourcePlan" },
                disabled: !selectedEditable,
                onClick: () => this.props.history.push(`/resources/plan`),
            } : undefined,
            RoutesAvailability.ReportedTime(subscription, user, routeAvailabilitySettings) ? {
                key: "reported-time",
                text: "Reported Time",
                iconProps: { iconName: "Clock" },
                disabled: !selectedEditable,
                onClick: () => this.props.history.push(`/resources/reported-time`),
            } : undefined,
            buildExportToCsvMenuItem({
                views: entitiesScreenProps.views,
                fields: entitiesScreenProps.fields,
                fakeFields: entitiesScreenProps.fakeFields,
                selectedItemIds: selectedItemIds,
                entityType: EntityType.Resource,
                activeSubView: activeSubView,
                selection: this._selection,
                onExportEntitiesToFile: resourcesActions.exportEntitiesToFile,
            }),
            selectedActiveCount > 0 ? {
                key: "deactivate",
                text: "Deactivate",
                iconProps: { iconName: "Blocked2" },
                disabled: !selectedEditable,
                onClick: () => this._onDeactivate(this.getSelected(ResourcesListStore.ResourceStatus.Active)),
            } : undefined,
            selectedCount !== selectedActiveCount ? {
                key: "activate",
                text: "Activate",
                iconProps: { iconName: "AddTo" },
                onClick: () => this._onActivate(this.getSelected(ResourcesListStore.ResourceStatus.Inactive)),
            } : undefined,
            selectedItemIds.length >= minCountMerge && selectedEditable ? {
                key: "merge",
                text: "Merge",
                iconProps: { iconName: "PeopleRepeat" },
                onClick: () => this.setState({ isMerge: true }),
            } : undefined,
            {
                ...layoutMenuItem,
                disabled: !selectedEditable,
            },
            {
                ...this._buildBulkApplyCalendarMenuItem(),
                disabled: !selectedEditable,
            },
            canCreateResource(this.props.user.permissions.resource)
                ? {
                    key: "delete",
                    text: "Delete",
                    title: MenuTitleBuilder.deleteSelectedTitle(EntityType.Resource),
                    iconProps: { iconName: "Delete" },
                    className: "more-deleteButton",
                    disabled: !canManage,
                    onClick: () => this._onRemove(selectedItems),
                }
                : undefined
        ].filter(notUndefined);
    };

    private readonly _buildBulkApplyCalendarMenuItem = (): IContextualMenuItem => {
        const selectedItems = this.props.resourcesMap.getItems(this.state.selectedItemIds);
        const disabled = selectedItems.some(_ => !_.isEditable);
        const uniqueCalendarIds = selectedItems.map(_ => _.calendar?.id).filter(distinct);

        return {
            key: "apply-calendar",
            onRender: () => <MenuButtonPicker
                text="Apply Calendar"
                iconProps={{ iconName: "Calendar" }}
                disabled={disabled}
                title={disabled ? "To use Apply Calendar action you must have Edit permissions to all selected projects" : undefined}
                findUrl="api/calendar/find"
                filter={{ entityType: ServerEntityType.Resource }}
                isItemDisabled={(item) => uniqueCalendarIds.length === 1 && uniqueCalendarIds[0] === item.id}
                onMenuItemClick={(item) => {
                    this.setState({ applyCalendar: { id: item.id, attributes: { Name: item.name } } as Calendar });
                }}
            />
        };
    }

    private _getSettings = () => mergeDefault<ResourcesSettings>(defaultResourcesSettings, this.props.views!.timeline.data as ResourcesSettings);

    private _getTimeTypes = (group: ResourceTimelineGroup): TimeType[] => {
        const timeType = this._getSettings()[group].timeType;
        return timeType
            ? Object.keys(timeType).filter(_ => timeType[_]) as TimeType[]
            : defaultTimeType;
    }

    private _buildSubTypeGroup = ({ key: group, title, iconName }: ViewTypeGroup): EntitiesScreenSubTypeGroup => ({
        key: group,
        title,
        iconName,
        isActive: () => this._getSettings().timelineGroup === group,
        subTypes: ViewsTypes.ResourceUsage.map(_ => ({
            title: _.title,
            iconName: _.iconName,
            isActive: () => this._getSettings()[group].viewType === _.type,
            onClick: () => {
                this.props.viewsActions.saveTimelineData({
                    parentSettingsPathKeys: [group],
                    valueBySettingNameMap: { [nameof<TimelineGroupSettings>('viewType')]: _.type }
                });
                this.props.viewsActions.saveTimelineData({
                    parentSettingsPathKeys: [],
                    valueBySettingNameMap: { [nameof<ResourcesSettings>('timelineGroup')]: group }
                });
            }
        }))
    });

    private _getTimelineResourceIds = () => this.state.selectedItemIds.length
        ? this.state.selectedItemIds
        : this.props.resources.map(_ => _.id);

    private _onAssignmentsTimeframeChanged = (resourceIds: string[], timeframe: IScalableTimeframe) => {
        this._timeframe = timeframe;
        if (this._getSettings().timelineGroup === 'assignments') {
            this._debouncedLoadAssignments(resourceIds, timeframe);
        }
    }

    private _loadDisplayedAssignmentsTotals() {
        const resourceIds = this._isAssignmentsTotalDisplayed() ? this.props.resources.map(_ => _.id) : [];
        if (arraysEqual(resourceIds, this._assignmentsTotalsResourceIds)) {
            return;
        }

        this._assignmentsTotalsResourceIds = resourceIds;
        if (resourceIds.length) {
            this._loadAssignmentsTotals(resourceIds);
        }
    }

    private _loadAssignments(resourceIds: string[], timeframe: IScalableTimeframe) {
        this.setState({ isLoadingAssignments: true });
        const { promise, cancelTokenSource } = cancellablePost<Dictionary<ServerAssignmentsByDay[]>>(`api/resource/assignments`,
            { ids: resourceIds, start: timeframe.startDate, end: timeframe.endDate });
        this._assignmentsCancelTokenSource = cancelTokenSource;
        promise
            .then(data => this.setState(state => ({
                assignmentsByDay: resourceIds.reduce((acc, _) => ({ ...acc, [_]: toAssignmentsByDay(data[_] ?? []) }), state.assignmentsByDay)
            })))
            .catch(defaultCatch())
            .finally(() => this.setState({ isLoadingAssignments: false }));
    }

    private _loadAssignmentsTotals(resourceIds: string[]) {
        const { promise, cancelTokenSource } = cancellablePost<Dictionary<AssignmentsTotals>>(`api/resource/assignments/totals`, { ids: resourceIds });
        this._assignmentsTotalsCancelTokenSource = cancelTokenSource;
        promise
            .then(data => this.setState(state => ({
                assignmentsTotals: resourceIds.reduce((acc, _) => ({ ...acc, [_]: data[_] ?? emptyAssignmentsTotals }), state.assignmentsTotals)
            })))
            .catch(defaultCatch());
    }

    private _isAssignmentsTotalDisplayed() {
        const { activeViewType, timeline } = this.props.views!;
        const subViews = timeline.subViews.allIds.map(_ => timeline.subViews.byId[_]);
        const activeSubView = subViews.find(_ => _.id === timeline.activeSubViewId) ?? subViews[0];
        return Subscription.contains(this.props.subscription, PPMFeatures.ResourceManagement)
            && (this.props.match.params.type ?? activeViewType) === Metadata.ViewTypes.timeline
            && this._getSettings().timelineGroup === 'assignments'
            && activeSubView.columns.some(_ => assignmentsTotalFields.some(__ => __.id === _.id));
    }

    private _getTimelineTotalFields = () => this._getSettings().timelineGroup === 'assignments' ? assignmentsTotalFields : [];

    private _renderAssignmentsTotal: OnItemRender<ResourcesListStore.Resource> = (entity, index, field, defaultRender) => {
        const totalField = assignmentsTotalFields.find(_ => _.id === field.id);
        if (!totalField) {
            return defaultRender();
        }

        const value = totalField.calculate(this.state.assignmentsTotals[entity.id]);
        return <span>{value === undefined ? null : formatFieldValue(value, totalField.settings?.format, this.props.user)}</span>;
    }

    private getTimelineView(): IEntitiesScreenView<ResourcesListStore.Resource> {
        const { timeline } = this.props.views!;
        const { isTimelineViewEdit } = this.state;
        const byId = timeline.subViews.byId;
        const fields = this.props.views!.list.fakeFields.concat(this.props.resourceFields, this._getTimelineTotalFields());
        const settings = this._getSettings();
        const { timelineGroup } = settings;
        const { viewType } = settings[timelineGroup];
        const timeType = this._getTimeTypes(timelineGroup);
        const isAssignments = timelineGroup === 'assignments';
        const timeTypesConfig = isAssignments ? assignmentTimeTypesConfigMap : timeTypesConfigMap;
        return {
            icon: 'PPMXTimelineView',
            url: 'timeline',
            subTypeGroups: [
                this._buildSubTypeGroup(ViewTypeGroups.ResourcePlan),
                this._buildSubTypeGroup(ViewTypeGroups.Assignments)
            ],
            subViews: timeline.subViews.allIds.map(_ => byId[_]),
            activeSubViewId: timeline.activeSubViewId,
            onSubViewChange: this.props.viewsActions.setTimelineActiveSubView,
            onAddSubViewClick: () => {
                const subView = Metadata.SubView.empty();
                this.props.viewsActions.addTimelineSubView(subView);
                this.props.history.push(`/resources/timeline/${subView.id}`);
                this.setState({ isTimelineViewEdit: true });
            },
            onEditSubViewClick: id => {
                if (timeline.activeSubViewId !== id) {
                    this.props.history.push(`/resources/timeline/${id}`)
                }
                this.setState({ isTimelineViewEdit: true });
            },
            onCopySubViewClick: this._onCopyTimelineSubView,
            onRemoveSubViewClick: this.props.viewsActions.removeTimelineSubView,
            render: (key: string, activeSubView: Metadata.ITimelineSubView, entities: ResourcesListStore.Resource[]) => {
                const listProps: Partial<IListProps> & ITimelineProps = {
                    buildRow: (_: ResourcesListStore.Resource) => ({
                        key: _.id,
                        entity: _,
                        segments: [],
                        markers: []
                    }),
                    renderSegmentContent: (row: IRow, segment: IScaleTimelineSegment) => {
                        return <ResourceUsageCell
                            viewType={viewType}
                            timeType={timeType}
                            summaryCalculator={isAssignments ? buildAssignmentsSummaryCalculator(this.state.assignmentsByDay) : calculateResourcePlanSummaryData}
                            timeTypesConfig={timeTypesConfig}
                            resource={row.entity as ResourcesListStore.Resource}
                            entityType={this.props.resourcePlanningLevel}
                            quantization={this.state.quantization}
                            prevStartDate={segment.prevStartDate}
                            startDate={segment.startDate}
                            finishDate={segment.finishDate} />;
                    },
                    renderSegmentTooltipContent: (row, segment) => isAssignments
                        ? <AssignmentsTooltipContent resource={row.entity as ResourcesListStore.Resource}
                            byDay={this.state.assignmentsByDay[row.entity.id]}
                            entityType={this.props.resourcePlanningLevel}
                            startDate={segment.startDate}
                            finishDate={segment.finishDate} />
                        : <UtilizationTooltipContent resource={row.entity as ResourcesListStore.Resource}
                            showPerEntityWork
                            entityType={this.props.resourcePlanningLevel}
                            startDate={segment.startDate}
                            finishDate={segment.finishDate} />,
                    onItemMenuRender: this._renderMenu,
                    onItemRender: this._renderAssignmentsTotal,
                    scaleRenderMode: ScaleRenderMode.Cell,
                    initialTimeframe: defaultTimeframe,
                    userQuantization: timeline.quantization,
                    userTimeframe: timeline.timeframe,
                    onScaleChange: (timelineChange) => {
                        const { origin, newState } = timelineChange;
                        origin && this.props.viewsActions.setTimelineScale(origin);
                        this.setState({ quantization: newState.quantization });

                        const resourceIds = this._getTimelineResourceIds();
                        onScaleChanged(resourceIds, this._debouncedLoadUsages, timelineChange);
                        onScaleChanged(resourceIds, this._onAssignmentsTimeframeChanged, timelineChange);
                    },
                    isVirtualizationDisabled: this.props.pngExportDetails?.isInProgress,
                    inlineEditProps: this.getInlineEditProps()
                };
                return <>
                    <ListSubView
                        key="timeline-view"
                        type="Timeline"
                        entities={entities}
                        entityType={EntityType.Resource}
                        selection={this._selection}
                        fields={fields}
                        isFieldFake={this._buildIsFieldFake()}
                        sort={timeline.sortBy}
                        sorter={this._sorter}
                        onSortChange={this.props.viewsActions.changeTimelineViewSort}
                        view={activeSubView}
                        listProps={listProps}
                        showSpinner={this.props.isLoadingUsage || (isAssignments && this.state.isLoadingAssignments)}
                        selectionModeItems={this._buildSelectedModeMenuItems(activeSubView)}
                        onColumnResized={(id, w) => this.props.viewsActions.onTimelineColumnResized(activeSubView.id, id, w)}
                        scaleMultiplier={this._getScaleMultiplier()}
                    />
                    {
                        isTimelineViewEdit && <EditListSubView
                            key="create-timeline-view"
                            subView={activeSubView}
                            entityType={EntityType.Resource}
                            selectedByDefault={timeline.selectedByDefault}
                            fields={fields}
                            onChange={changes => {
                                this.props.viewsActions.updateTimelineSubView(activeSubView.id, changes);
                            }}
                            onSave={() => {
                                this.props.viewsActions.saveTimelineSubView(activeSubView, 'resources');
                                this.setState({ isTimelineViewEdit: false })
                            }}
                            onCopy={() => this._onCopyTimelineSubView(activeSubView)}
                            onDismiss={() => this.setState({ isTimelineViewEdit: false })}
                        />
                    }
                </>
            },
            headerSideItems: [
                {
                    key: 'time-type-selector',
                    onRender: () => <TimeTypeSelector<TimeType>
                        timeType={timeType}
                        allTimeTypes={Object.values(timeTypesConfig)}
                        onTimeTypeChange={(changedType, checked) => this.props.viewsActions.saveTimelineData({
                            parentSettingsPathKeys: [timelineGroup, nameof<TimelineGroupSettings>('timeType')],
                            valueBySettingNameMap: Object.values(timeTypesConfig).reduce((acc, { type }) => ({ ...acc, [type]: type === changedType ? checked : timeType.includes(type) }), {})
                        })} />
                }
            ]
        }
    }

    private _canEdit() {
        return canResourceAnyRead(this.props.user.permissions.resource) || this.props.resources.some(_ => _.isEditable);
    }

    private _onCopyTimelineSubView = (view: Metadata.ITimelineSubView) => {
        const subView = Metadata.SubView.copy(view);
        this.props.history.push(`/resources/timeline/${subView.id}`);
        this.setState({ isTimelineViewEdit: true });
        this.props.viewsActions.saveTimelineSubView(subView, 'resources', undefined, view.id);
    }

    private gridBulkUpdate = (updates: Dictionary<any>) => {
        this.props.resourcesActions.bulkUpdate(updates);
    }

    private getSelected(status: ResourcesListStore.ResourceStatus) {
        return this.props.resourcesMap.getItems(this.state.selectedItemIds).filter(_ => _.attributes.Status === status);
    }

    private _sorter: Sorter<ResourcesListStore.Resource> = (orderBy) => {
        const { list } = this.props.views!;
        const fields = list.fakeFields.concat(this.props.resourceFields, this._getTimelineTotalFields());
        const isFieldFake = this._buildIsFieldFake();
        const now = new Date();
        const extractor = (item: ResourcesListStore.Resource, field: Metadata.Field) => {
            if (field.name === LayoutsStore._layoutFakeFieldName) {
                return item.layoutId ? this.props.layouts.byId[item.layoutId]?.name : null;
            }

            const totalField = assignmentsTotalFields.find(_ => _.id === field.id);
            if (totalField) {
                return totalField.calculate(this.state.assignmentsTotals[item.id]);
            }

            if (field.type === Metadata.FieldType.TimephasedValue) {
                return tryGetTimephasedValueFromResource(field.name, item, now, this.props.defaultCostRateTable?.id);
            }

            return SortService.getFieldValueBaseImpl(field, item, isFieldFake)
        }

        const fieldsMap = Metadata.toMap(fields, isFieldFake);
        return (a, b) => SortService.getComparer(fieldsMap, orderBy, isFieldFake, extractor)(a, b);
    };

    private _buildIsFieldFake = (): (_: Metadata.Field) => boolean => {
        const { list } = this.props.views!;
        const fakeMap = toDictionaryById(list.fakeFields);
        return (_: Metadata.Field) => !!fakeMap[_.id];
    }

    private _getViews = () =>
        [
            this.getListView(),
            Subscription.contains(this.props.subscription, PPMFeatures.ResourceManagement) ? this.getTimelineView() : undefined
        ].filter(notUndefined);

    private _getActiveViewType = () => {
        const views = this._getViews();
        const { activeViewType } = this.props.views!;
        return activeViewType && views.find(_ => _.url === activeViewType)
            ? activeViewType.toLowerCase()
            : views[0].url.toLowerCase();
    }

    private _getPngExportConfig = (): PngExportConfig => {
        const av = this._getActiveViewType();
        const activeView: Metadata.ViewTypes | undefined = av
            ? Metadata.ViewTypes[av as keyof typeof Metadata.ViewTypes]
            : undefined;
        return {
            ...getPngExportConfigSelectors(activeView),
            name: "Resources",
            controlId: ResourcesList.name,
            activeView,
            rowsCount: this.applyFilter(this.props.resources).length
        };
    }

    private _getScaleMultiplier = (): number => {
        return this._getTimeTypes(this._getSettings().timelineGroup).length + SCALE_MULTIPLIER_PER_TIMETYPE_COLUMN;
    }
}

const assignmentsTotalFields = buildAssignmentsTotalFields(value => (totals: AssignmentsTotals | undefined) => totals && value(totals));

const emptyAssignmentsTotals: AssignmentsTotals = {
    effort: 0,
    completedWork: 0,
    remainingWork: 0,
    estimatedCharge: 0,
    estimatedCost: 0,
    actualCharge: 0,
    actualCost: 0
};

const buildAssignmentsSummaryCalculator = memoizeFunction((assignmentsByDay: Dictionary<Dictionary<AssignmentsWork>>) =>
    (startDate: Date, finishDate: Date, context: CellSummaryContext) =>
        calculateAssignmentsSummaryData(startDate, finishDate, context, assignmentsByDay[context.resource.id]));

function mapStateToProps(state: ApplicationState, ownProps: RouteComponentProps<{}>): StateProps {
    const fields = state.fields[EntityType.Resource];
    const filters = FiltersStore.getFilter(state.filters, EntityType.Resource);
    const autoFilterId = filters.all.find(_ => _.isBuiltIn && _.name.startsWith('All'))?.id ?? filters.all[0].id; //not getAutoFilterId, because it returns Active, not All

    return {
        resources: state.resources.allIds.map(_ => state.resources.byId[_]).filter(_ => _.canView),
        resourcesMap: useEntityMapHelper(state.resources.byId),
        layouts: state.layouts[EntityType.Resource],
        resourceFields: fields.allIds.map(_ => fields.byId[_]),
        resourceFakeFields: state.views[EntityType.Resource].list.fakeFields,
        resourceFilters: filters.all,
        activeFilter: filters.active.filter,
        autoFilterId: autoFilterId,
        resourceReports: state.tenant.reporting.resourceReports.subPacks,
        resourcesReports: state.tenant.reporting.resourcesReports,
        views: state.views[EntityType.Resource],
        deletionResult: state.resources.deletionResult,
        user: state.user,
        defaultCostRateTable: getDefaultCostRateTable(state),
        fieldsStore: state.fields,
        isImportDialogOpen: state.import.resources.isDialogOpen,
        isLoading: state.resources.isLoading,
        isListLoading: state.resources.isListLoading,
        isLoadingUsage: state.resources.isLoadingUsage,
        subscription: state.tenant.subscription,
        integrations: new Integrations(state.tenant.subscription.integrations),
        pngExportDetails: state.pngExporter.controls[ResourcesList.name],
        resourcePlanningLevel: mapServerEntityType[state.tenant.resourcePlanningSettings?.resourcePlanningLevel!]!,
        routeAvailabilitySettings: ToRouteAvailabilitySettings(state.tenant)
    };
}

function mergeActionCreators(dispatch: any): ActionProps {
    return {
        resourcesActions: bindThunkActionCreators(ResourcesListStore.actionCreators, dispatch),
        notificationsActions: bindActionCreators(Notifications.actionCreators, dispatch),
        filtersActions: bindActionCreators(FiltersStore.actionCreators.forEntity(EntityType.Resource), dispatch),
        viewsActions: bindActionCreators(ViewsStore.actionCreators.forEntity(EntityType.Resource), dispatch),
    }
}

export default connect(mapStateToProps, mergeActionCreators)(withSearch(ResourcesList));